import store from '../store'
import router from "../router";

export default class UserUtil {

    static hasRole(search) {

        let roleArray = store.getters['userModel/getRoles'];

        let searchedRole = roleArray.find( function (role) {
            return role.role === search
        });

        return !!searchedRole;

    }

    static hasPermission(search) {
        let roleArray = store.getters['userModel/getRoles'];

        let match = 0;
        roleArray.forEach(function(role) {
            role.permissions.forEach(function (permission) {
                if (permission.name === search) {
                    match++;
                }
            })
        });

        return match > 0;
    }

    static checkUserRole() {
        let token;
        try {
            token = localStorage.getItem('token').replace("Bearer ", "");
        } catch (e) {
            router.push("/login");
            return false;
        }
        //const {roles, permissions} = this.getUserPermissions();
        if(token !== null || token !== undefined) {
            return true
            //return JSON.stringify(token.role.sort()) === JSON.stringify(roles.sort()) && JSON.stringify(token.permission.sort()) === JSON.stringify(permissions.sort())
        }
        else {
            return false;
        }
    }

    static getUserPermissions() {
        let userPermissions = {
            permissions: [],
            roles: []
        };

        let roleArray = store.getters['userModel/getRoles'];

        roleArray.forEach( role => {
            userPermissions.roles.push(role.role);
            if (role.permissions) {
                role.permissions.forEach(permission => {
                    userPermissions.permissions.push(permission.name);
                })
            }
        });

        return userPermissions;
    }

    static userHasEESZTPermission() {
        let user = store.getters['userModel/getUser'];
        return user.eesztUsername && this.hasRole("ROLE_EESZT_DOCTOR");
    }

    static userIs2FAUser() {
        let user = store.getters['userModel/getUser'];
        return !!user && !!user.isTwoFactorAuthenticationUser;
    }

}
